module.exports = __webpack_public_path__ + "static/media/photo206.7401e8ea.jpg";